import React from "react";
import styled from "styled-components";

export const ModalBackdrop = ({ children, closeModal }) => {
	return <Overlay onClick={closeModal}>{children}</Overlay>;
};

// styled

const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.8);
	z-index: 1200;
`;
